import React, { FunctionComponent, FormEvent } from 'react';
import { CompanyForm, SelectOption, UserAuthForm } from '../../../types/companyRegisterForm';
import { CompanyRegisterProfileFormTextBox } from '../../molecules/companyRegisterProfileFormTextBox';
import { CompanyRegisterProfileFormSelect } from '../../molecules/companyRegisterProfileFormSelect';
import { Loading } from '../../atoms/loading';
import { OSHIRI_OPTIONS, RIYOHOHO_OPTIONS } from './constants';


type Props = {
  company: CompanyForm;
  userAuth: UserAuthForm;
  isLoading: boolean;
  handleChange: (section: 'company' | 'userAuth' | 'planPurchase', field: string, value: string | boolean| number) => void;
  onSubmit: (e: FormEvent) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  company,
  userAuth,
  isLoading,
  handleChange,
  onSubmit
}) => {
  return (
    <>
      {isLoading && (
        <div className="overall-loading">
          <Loading />
        </div>
      )}
      <form onSubmit={onSubmit}>
        <div className="form-wrapper">
          {/* 企業名 */}
          <CompanyRegisterProfileFormTextBox
            section="company"
            name="name"
            divClassName="form-group column"
            labelName="企業名・団体名"
            labelHtmlFor="company-name-input"
            required={true}
            inputId="company-name-input"
            inputClassName="form-control"
            placeholder="（例）株式会社 READY TO FASHION"
            value={company.name}
            onChange={handleChange}
          />
          {/* ホームページURL */}
          <CompanyRegisterProfileFormTextBox
            section="company"
            name="url"
            divClassName="form-group column"
            labelName="ホームページURL"
            labelHtmlFor="website-input"
            required={false}
            inputId="website-input"
            inputClassName="form-control"
            placeholder="（例）https://readytofashion.jp"
            value={company.url}
            onChange={handleChange}
          />
          {/* 担当者名 */}
          <CompanyRegisterProfileFormTextBox
            section="company"
            name="staffName"
            divClassName="form-group column"
            labelName="貴社担当者名"
            labelHtmlFor="name-input"
            required={true}
            inputId="name-input"
            inputClassName="form-control minWidth"
            placeholder="（例）高野 聡司"
            value={company.staffName}
            onChange={handleChange}
          />
          {/* 電話番号 */}
          <CompanyRegisterProfileFormTextBox
            section="company"
            name="phoneNumber"
            divClassName="form-group column"
            labelName="貴社担当者の電話番号"
            labelHtmlFor="phone-number-input"
            required={true}
            inputId="phone-number-input"
            inputClassName="form-control minWidth"
            placeholder="（例）0123456789"
            value={company.phoneNumber}
            onChange={handleChange}
            hintMessage="※採用担当者様にご連絡がつきやすい番号をご入力ください"
            hintId="tel-help-message"
          />
          {/* 利用方法 */}
          <CompanyRegisterProfileFormSelect
            section="company"
            name="riyohoho"
            divClassName="form-group column none"
            labelName="利用方法"
            labelHtmlFor="riyohoho-input"
            required={false}
            selectId="riyohoho-input"
            selectClassName="form-control select width"
            value={company.riyohoho}
            onChange={handleChange}
            options={RIYOHOHO_OPTIONS}
          />
          {/* サービスを知ったきっかけ */}
          <CompanyRegisterProfileFormSelect
            section="company"
            name="oshiri"
            divClassName="form-group column"
            labelName="弊社サービスを知ったきっかけ"
            labelHtmlFor="oshiri-input"
            required={true}
            selectId="oshiri-input"
            selectClassName="form-control select width"
            value={company.oshiri}
            onChange={handleChange}
            options={OSHIRI_OPTIONS}
          />
          {/* メールアドレス */}
          <CompanyRegisterProfileFormTextBox
            section="userAuth"
            name="email"
            divClassName="form-group column"
            labelName="メールアドレス"
            labelHtmlFor="email-input"
            required={true}
            inputId="email-input"
            inputClassName="form-control"
            placeholder="（例）takano@example.co.jp"
            value={userAuth.email}
            onChange={handleChange}
            hintMessage="※ログインIDにもなりますので正確にご入力ください"
          />
          {/* パスワード */}
          <CompanyRegisterProfileFormTextBox
            section="userAuth"
            name="password"
            divClassName="form-group column margin"
            labelName="パスワード"
            labelHtmlFor="password-input"
            required={true}
            inputId="password-input"
            inputClassName="form-control"
            value={userAuth.password}
            onChange={handleChange}
            type='password'
          />
          {/* パスワード（確認） */}
          <CompanyRegisterProfileFormTextBox
            section="userAuth"
            name="passwordConfirmation"
            divClassName="form-group column"
            labelName="パスワード（確認）"
            labelHtmlFor="password-check-input"
            required={true}
            inputId="password-check-input"
            inputClassName="form-control"
            value={userAuth.passwordConfirmation}
            onChange={handleChange}
            type='password'
          />
          {/* 送信ボタン */}
          <button type="submit" className="button-agree center">次へ</button>
        </div>
      </form>
    </>
  );
};
